import { cn } from "@/lib/utils";
import { Typography } from "@backpac/monica";

export function TicketStatusChip({
  dotClassName,
  textClassName,
  label,
}: { dotClassName: string; textClassName: string; label: string }) {
  return (
    <span
      className={cn("inline-flex items-center gap-[6px] rounded-[10px] px-2 py-1 bg-backgroundLight", textClassName)}
    >
      <span className={cn("w-1.5 h-1.5 rounded-full flex-shrink-0", dotClassName)} />
      <Typography size="xs" weight={500} asChild>
        <span>{label}</span>
      </Typography>
    </span>
  );
}

export function DeliveryStatusChip({
  icon,
  textClassName,
  bgClassName,
  label,
}: {
  icon: string;
  textClassName: string;
  bgClassName: string;
  label: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-[10px] px-2 py-1", bgClassName, textClassName)}>
      <i className={cn("inline-block size-3.5 flex-shrink-0", icon)} />
      <Typography size="xs" weight={500} asChild className={textClassName}>
        <span>{label}</span>
      </Typography>
    </span>
  );
}
